import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.mitteilungs-vorlage-kopieren';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationMitteilungsVorlageKopierenEffects {

    MitteilungsVorlageKopieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_MITTEILUNGS_VORLAGE_KOPIEREN),
        mergeMap((x: ac.PostMitteilungsVorlageKopierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postMitteilungsVorlageKopieren(x.mitteilungsVorlageRequest).pipe(
                map((result: any) => {
                    return new ac.PostMitteilungsVorlageKopierenErfolgreichAction(result, x.mitteilungsVorlageRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostMitteilungsVorlageKopierenFehlerAction(error, x.mitteilungsVorlageRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MitteilungsVorlageCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MitteilungsVorlageCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.MitteilungsVorlageCommandService);
        }
        return this.service;
    }
}
